import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from "react-redux";
import { store } from './store';

import SlideGame from './games/SlideGame';
import MineGame from './games/MineGame';
import VideoPoker from "./games/VideoPoker";
import Layout from './layout';
import CrashGame from './games/CrashGame';
import BaccaratGame from './games/BaccaratGame';
import HiloGame from './games/HiloGame';
import GoalGame from './games/GoalGame';
import BlackjackGame from './games/BlackjackGame';
// import RouletteGame from './games/RouletteGame';
// import BaccaraStGame from './games/BaccaratSGame';
// import HiloMGame from './games/HiloMGame';

function App() {
  // Detect base depending on where the bundle is served
  const path = window.location.pathname;
  const base = path.includes('/games/react-video-poker')
    ? '/games/react-video-poker'
    : '/games/video-poker';

  return (<div className="flex-grow bg-[#10100f]">
    <ToastContainer />
    <Provider store={store}>
      {/* Serve under /games/video-poker or /games/react-video-poker */}
      <Router basename={base}>
        <Routes>
          <Route path="/" element={<Layout />} >
            {/* Default to Video Poker */}
            <Route index element={<VideoPoker />} />
            <Route path="/video-poker" element={<VideoPoker />} />
            <Route path="/mine" element={<MineGame />} />
            <Route path="/slide" element={<SlideGame />} />
            <Route path="/crash" element={<CrashGame />} />
            <Route path="/baccarat" element={<BaccaratGame />} />
            <Route path="/hilo" element={<HiloGame />} />
            <Route path="/goal" element={<GoalGame />} />
            <Route path="/blackjack" element={<BlackjackGame />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  </div>
  );
}

export default App;
